exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".LoadSection ol {\n  list-style: decimal;\n  padding-left: 15px;\n  padding-top: 15px;\n  padding-bottom: 15px; }\n\n.LoadSection ul {\n  list-style: circle;\n  padding-left: 15px;\n  padding-top: 15px;\n  padding-bottom: 15px; }\n\n.Swift__Table .Table__Cell {\n  cursor: auto; }\n\n.VerifyLink {\n  cursor: pointer;\n  color: #ff9b1e; }\n\n@media screen and (max-width: 500px) {\n  .LoadSection {\n    padding-top: 0;\n    margin-bottom: 0; } }\n", ""]);

// exports
